// extracted by mini-css-extract-plugin
export default {"form":"Profile_form__IDWok"};